
import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import './App.css';
import { Header, Navbar } from './components';
import Footer from './containers/footer/Footer';
function App() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isValidLang, setIsValidLang] = useState(false);
  let params = useParams();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const isvalid = params.lang === "it" || params.lang === "en" || params.lang === undefined;
    setIsValidLang(isvalid);
    if (isvalid) {
      i18n.changeLanguage(params.lang)
    }
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page_title: window.location.pathname });
  }, [window.location.pathname]);

  return (
    <>
      {isValidLang ?
        <>
          <div className='int__nav_head-container'>
            <Navbar {...{ toggleMenu: toggleMenu, setToggleMenu: setToggleMenu }} />
            <Header {...{ setToggleMenu: setToggleMenu }} />
          </div>
          <Footer home={true} />
          <Outlet />
        </>
        : null
      }
    </>
  );
}

export default App;
